import React from 'react';
import { Box, Typography } from '@mui/material';

import { RemoveIcon, ArrowDownwardIcon, ArrowUpwardIcon } from '@occc-app/design-system';
import { readableNumber } from '@occc-app/lib/format';

import { Metric } from '../types';

type MetricSnapshotProps = {
  label: string;
  metric: Metric;
  isSelected?: boolean;
  formatValue?: (value: number) => string;
};

export const MetricSnapshot = ({ label, metric, formatValue }: MetricSnapshotProps) => {
  const renderMetricComparisonValue = () => {
    if (metric.priorSubtotal === 0) {
      return <RemoveIcon fontSize='small' />;
    }

    const comparisonValue = Math.round((metric.subtotal / metric.priorSubtotal - 1) * 100);

    const color = comparisonValue > 0 ? 'primary' : comparisonValue < 0 ? 'error' : 'textSecondary';

    const comparisonIcon =
      comparisonValue > 0 ? (
        <ArrowUpwardIcon fontSize='small' color='inherit' />
      ) : comparisonValue < 0 ? (
        <ArrowDownwardIcon fontSize='small' color='inherit' />
      ) : (
        <RemoveIcon fontSize='small' />
      );

    return (
      <Typography color={color} variant='caption' display='flex' alignItems='center'>
        {comparisonIcon}
        <Box mx={0.5} component='span' />
        {readableNumber(comparisonValue)}%
      </Typography>
    );
  };

  const formattedValue = !formatValue
    ? readableNumber(metric.subtotal)
    : formatValue(metric.subtotal);

  return (
    <Box display='flex' alignItems='center' flexDirection='column' p={4}>
      <Typography variant='button' color='textSecondary' gutterBottom align='center'>
        {label}
      </Typography>
      <Typography variant='h4' gutterBottom>
        {formattedValue}
      </Typography>
      {renderMetricComparisonValue()}
    </Box>
  );
};
